export default function (value) {
  // const basicValid = new RegExp("^([0-9]{4}-[0-9]{2}-[0-9]{2})?$").test(value);
  const basicValid = new RegExp("^([0-9]{1,2}/[0-9]{1,2}/[0-9]{4})?$").test(value);
  if (basicValid === true) {
    const split = value.split('/');
    let lst = moment().startOf('day').year(parseInt(split[2])).month(parseInt(split[0])-1).date(parseInt(split[1])).format('M/D/YYYY');
    // console.log(`lst=${lst}, value=${value}`);
    return lst === value;
  }
  return basicValid;
}
